import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'commaSplit',
    standalone: false
})
export class CommaSplitPipe implements PipeTransform {
    transform(value: string | null | undefined): string[] {
        if (value === null || value === undefined || value === '') {
            return [];
        }
        const str = String(value);
        if (!str.includes(',')) {
            return [str];
        }
        return str.split(',').map(s => s.trim()).filter(s => s.length > 0);
    }
}
